import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/css/mdb.min.css'
import Vue from 'vue/dist/vue.js';
import VueRouter from 'vue-router'


import App from './App'
import Home from './components/Home'
import CorrosionDataset from "./components/staticComponents/CorrosionDataset"

// Vue.prototype.$http = Axios;
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
Vue.use(VueRouter)

Vue.config.productionTip = false

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/corrosion_dataset',
    name: 'corrosion_dataset',
    component: CorrosionDataset
  }
]


const router = new VueRouter({
  mode: 'history',
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
        offset: { x: 0, y: to.name=="corrosion_dataset"?100:40 }
      }
    }
  }
})


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
